export default __webpack_public_path__ + "static/media/fetus.74ad895f.png";